<iboxtools *ngIf="verDetalle" [Title]="" 
            isHistory='true' 
            [enableBack]="true" 
            [DateInit]="ausentismo?.desde" 
            [DateEnd]="ausentismo?.hasta"
            [IsEditing]="isEditing" 
            (BackChange)="OnBackChange()" 
            [PeriodList]="ausentismoHistoryList" 
            (DeleteChange)="OnDeleteChange($event)" 
            (NewChange)="OnNewChange($event)"
            (EditChange)="OnEditChange($event)" 
            (PeriodChange)="OnPeriodChange($event)" 
            (CancelChange)="OnCancelChange($event)" 
            (SaveChange)="OnSaveChange($event)" 
            (CutChange)="OnCutChange()"
            [Permiso]="permisoEdicion"
            [enableCut]=false
            [CurrentPeriod]="ausentismo?.id">
</iboxtools>

<app-ausentismos-list *ngIf="!verDetalle && !buscando" [personalId]="personalId" 
                                                         [ausentismos]="ausentismos" 
                                                         [permisoEdicion]="permisoEdicion"
                                                         (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-ausentismos-list>

<app-ausentismos-detalle #ChildAusentismoDetalle [ausentismo]="ausentismo" *ngIf="verDetalle" 
                          [enabledForm]="habilitarFormDetalle" 
                          [MensajeError]="MensajeError" 
                          [desdeAnterior]="desdeAnterior" 
                          [ingreso]="ingreso"
                          [anteriorRetroactividad]="anteriorRetroactividad" 
                          [grupoLiq]="gruposLiquidaciones" 
                          [ausentismosInvalida]="ausentismosInvalida">
</app-ausentismos-detalle>

